import { ColorFragment, isColorFragment } from './ColorFragment'

import textFragmentFragmentRawString from '../TextFragmentFragment.graphql'

export const textFragmentFragmentString = textFragmentFragmentRawString

export type TextFragmentFragment = {
  text: string
  textColor: ColorFragment
  font: {
    id: string
    fontName: string
  }
  fontSize: number
  isReplacement: boolean
}

export const isTextFragmentFragment = (
  fragment: any,
): fragment is TextFragmentFragment =>
  fragment &&
  typeof fragment.text === 'string' &&
  (isColorFragment(fragment.textColor) as boolean) &&
  fragment.font &&
  typeof fragment.font.id === 'string' &&
  typeof fragment.font.fontName === 'string' &&
  typeof fragment.fontSize === 'number' &&
  typeof fragment.isReplacement === 'boolean'
